import { render, staticRenderFns } from "./filters-wide.vue?vue&type=template&id=5e518509&scoped=true"
import script from "./filters-wide.vue?vue&type=script&lang=js"
export * from "./filters-wide.vue?vue&type=script&lang=js"
import style0 from "./filters-wide.vue?vue&type=style&index=0&id=5e518509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e518509",
  null
  
)

export default component.exports